<template>
  <a-modal
    :title="$t('page_ops_custom_device')"
    :visible="visible"
    @cancel="cancel"
    @ok="ok"
    :confirmLoading="confirmLoading"
  >
    <a-form
      :form="ruleForm"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-row>
        <a-col :span="24">
          <a-form-item :label="$t('page_business_device_type')">
            <a-select
              v-decorator="[
                'deviceTypeId',
                {
                  initialValue: form.deviceTypeId || '',
                }
              ]"
              allowClear
            >
              <a-select-option :key="index" :value="item.id" v-for="(item, index) in typeList">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('page_card_workstation_name')">
            <a-input
              :placeholder="$t('page_device_edit_please_enter_the_device_name')"
              :maxLength="48"
              v-decorator="[
                'deviceName',
                {
                  initialValue: form.deviceName || '',
                  rules: [
                    {
                      required: true,
                      message: $t('page_device_edit_please_enter_the_device_name')
                    }
                  ]
                },
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('page_ops_machine_machine_serialNo')">
            <a-input
              :placeholder="$t('page_getwat_list_select_work_id')"
              :maxLength="48"
              v-decorator="[
                'deviceCode',
                {
                  initialValue: form.deviceCode || '',
                  rules: [
                    {
                      required: true,
                      message: $t('page_getwat_list_select_work_id')
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item :label="$t('page_ops_machine_model_machine_deliveryTime')">
            <a-date-picker
                v-decorator="[
                'deliveryTime',
                {
                  initialValue: form.deliveryTime || '',
                }
              ]"
              format="YYYY-MM-DD"
              type="date"
              :placeholder="$t('please_select') + $t('page_ops_machine_model_machine_deliveryTime')"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {
        return {
          customerId: '',
          deviceCode: '',
          deviceName: '',
          deviceTypeId: '',
          id:'',
          remark: '',
          deliveryTime: null
        }
      }
    },
    typeList: {
      type: Array,
      default: ()=>[]
    }
  },
  data() {
    return {
      confirmLoading: false,
      ruleForm: this.$form.createForm(this,this.form)
    }
  },
  methods: {
    ok(){
      this.ruleForm.validateFields((err, values) => {
        if (!err) {
          let data = {...values, ...{customerId: this.form.customerId}}
          if(this.form.id){
            data.id=this.form.id;
          }else{
            data.id = '';
          }
          this.$emit('ok',data)
        }
      })
    },
    cancel(){
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-header {
  background: #f8f8f8;
  font-weight: bold;
}
/deep/ .ant-modal-footer {
  background: #f8f8f8;
}
.buttom-save-primary {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
  color: #fff;
}
/deep/ .ant-btn-icon-only.ant-btn-sm {
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 14px;
  border-radius: 0;
}
</style>
